import { render } from "./Price.vue?vue&type=template&id=0c53c522"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__